<template>
  <el-row style="margin-top: -10px" >
    <el-col>
      <el-row style="margin-bottom: 10px">
        <el-card class="box-card">
          <el-button-group >
            <el-button type="success" icon="el-icon-circle-plus"  size="mini" @click="DialogVisible = true">添加数据</el-button>
            <el-button type="primary" icon="el-icon-refresh"  size="mini" @click="refreshData">刷新显示</el-button>
            <el-button type="warning" icon="el-icon-picture-outline-round"  size="mini" @click="queryData">数据用量</el-button>
            <el-button icon="el-icon-search" size="mini" @click="searchData">搜索号码</el-button>
          </el-button-group>
          <el-input
              placeholder="搜索的数据"
              v-model="pagParams.searchval"
              clearable
              style="height: 30px; width: 150px;margin-left: 10px;margin-right: 10px"
              >
          </el-input>

        </el-card>
      </el-row>
      <el-popover
          placement="right"
          width="80%"
          trigger="manual"
          v-model="visibleLab">
        <el-table :data="labData" :row-class-name="tableRowClassName" v-loading="loadingLab" border>
          <el-table-column width="80" property="total" label="总数"></el-table-column>
          <el-table-column width="80" property="status_u" label="已使用"></el-table-column>
          <el-table-column width="80" property="status_0" label="未使用"></el-table-column>
          <el-table-column width="80" property="status_2" label="成功"></el-table-column>
          <el-table-column width="80" property="status_e" label="错误"></el-table-column>
          <el-table-column width="80" property="status_1" label="正在注册"></el-table-column>
        </el-table>
      </el-popover>
    </el-col>

    <el-col style="margin-top: -5px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.pagParams.page"
          :page-sizes="[20, 50,100, 200, 500]"
          :page-size="this.pagParams.limit"
          :total="this.pagParams.total"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-col>
    <el-card class="box-card" >

    <el-table
        class="el-ta"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        size="mini"
        highlight-current-row
        highlight-selection-row
        :default-sort = "{prop: 'sort', order: 'ascending'}"

    >

      <!--      <el-table-column-->
      <!--          prop="sort"-->
      <!--          label="序号"-->
      <!--          width="80px"-->
      <!--          sortable-->
      <!--          show-overflow-tooltip>-->
      <!--        <template slot-scope="scope">{{ scope.$index+1 }}</template>-->
      <!--      </el-table-column>-->
      <el-table-column

          fixed="left"
          label="操作"
          width="80">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" type="text"  size="small" @click="_showAuthDlg(scope.row)">验证码</el-button>
          <el-button icon="el-icon-error" type="text" size="mini" @click="delData(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="data"
          label="号码"
          width="100px"
      >
      </el-table-column>

      <el-table-column
          prop="status"
          label="状态"
          width="100px"
          sortable
          :filters="[
           { text: '未使用',value: 0 },
           { text: '正在注册', value: 1 },
           { text: '注册成功', value: 2 },
           { text: '辅助错误', value: 3 },
           { text: '人脸错误', value: 4 },
           { text: '短信验证', value: 5 },
           { text: '其他错误', value: 6 },
           ]"
          :filter-method="filterStatus"
          filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
              :type=getMsgColor(scope.row.status)
              disable-transitions>{{getMsg(scope.row.status)}}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
          prop="msg"
          label="提示"
          width="150px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="auth"
          label="验证码"
          width="100px"
          sortable
          show-overflow-tooltip
      >
        <template slot-scope="scope" v-if="scope.row.auth">
          <el-tag type="success" disable-transitions>
            {{scope.row.auth}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="ks"
          label="卡商"
          width="100px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="use_time"
          label="使用时间"
          width="150px"
          sortable
          show-overflow-tooltip
          :formatter="fDate"
      >
      </el-table-column>
      <el-table-column
          prop="lab"
          label="备注"
          width="100%"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="work"-->
<!--          label="操作">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button  icon="el-icon-edit"  size="mini" @click="_showAuthDlg(scope.row)">设置验证码</el-button>-->
<!--          <el-button  icon="el-icon-edit"  size="mini" @click="_showChangDlg(scope.row)">修改</el-button>-->
<!--          <el-button  icon="el-icon-error" size="mini" @click="delData(scope.row.id)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->

    </el-table>
    </el-card>

    <el-dialog
        :visible.sync="DialogVisible"
        width="80%"
    >
      <el-form ref="form" :model="formAdd" label-width="20px">
        <el-form-item label="号码">
          <el-input type="textarea" :rows="10" v-model="tmp" :show-word-limit=true style="width: 90%;margin-left: 10px;margin-right: 10px;margin-top: -10px"></el-input>
        </el-form-item>
        <el-form-item>
          <!--          <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button type="primary" @click="_addData">确 定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog
        :visible.sync="dlgShow_Auth"
        width="80%"
        title="设置验证码"
    >
      <el-card class="box-card" style="margin-top: -20px">
        <el-form ref="formChange" :model="formChange" label-width="60px" >
          <el-form-item label="验证码">
            <el-input v-model="formChange.auth" style="width: 100%;margin-right: 10px;margin-top: -10px" clearable></el-input>
          </el-form-item>

          <el-form-item >
            <el-button type="primary" @click="postAuth">确认修改</el-button>
          </el-form-item>

        </el-form>
      </el-card>

    </el-dialog>
  </el-row>

</template>

<script>


import {trim} from "core-js/internals/string-trim";

export default {

  data() {
    return {
      userName : '',
      ks:'',
      intervalId: null,
      apptype:2,
      tableData: [],
      multipleSelection: [],
      DialogVisible:false,
      dlgShow_Change:false,
      dlgShow_Auth:false,
      visibleLab : false,
      pagParams:{
        total:20,limit:20,page:1,searchval:''
      },
      formAdd: {
        data:[], status:0,
      },
      formChange:{
        id:null,
        status:null,
        msg:'',
        tmp:null,
        auth:'',
        phone:'',
        lab:'',
      },
      labData: [],
      file: null,
      tmp:'',
      loadingLab:true,
      opStatus:[
        { label:"未使用" , value:0},
        { label:"正在注册", value:1},
        { label:"注册成功", value:2},
        { label:"辅助错误", value:3},
        { label:"人脸错误", value:4},
        { label:"已被注册", value:5},
        { label:"其他错误", value:6},
        { label:"验证码超错误", value:7},
        { label:"验证码超时", value:8},
      ]
    }
  },
  created() {


  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  mounted() {
    this.userName = this.$route.query.belong;
    this.ks = this.$route.query.ks;
    document.title = this.ks;

    this.getData();
    this.intervalId = setInterval(this.getData, 3000);

  },
  methods: {

    _showAuthDlg(row){
      this.formChange.id = row.id;
      this.formChange.phone = row.data;
      this.formChange.auth = '';
      this.dlgShow_Auth = true;
    },
    _showChangDlg(row){
      this.formChange.status = row.status;
      this.formChange.msg = row.msg;
      this.formChange.id = row.id;
      this.formChange.phone = row.data;
      this.formChange.lab = row.lab;

      this.dlgShow_Change = true;
    },
    getMsgColor(status){
      let result = '';
      if(status === 0){
        result = 'info';
      }else if(status === 1){
        result = 'primary';
      }else if(status === 2){
        result = 'success';
      }else {
        result = 'danger';
      }
      // scope.row.status > 2 ? 'danger' : 'success'";
      return result;
    },
    getMsg(status){
      let result = '';
      if(status === 0){
        result = '未使用';
      }else if(status === 1){
        result = '正在注册';
      }else if(status === 2){
        result = '注册成功';
      }else if(status === 3){
        result = '辅助错误';
      }else if(status === 4){
        result = '人脸错误';
      }else if(status === 5){
        result = '已被注册';
      }else if(status === 6){
        result = '其他错误';
      }else if(status === 7){
        result = '验证码错误';
      }else if(status === 8){
        result = '验证码超时';
      }else{
        result = '其他错误';
      }
      return result;
    },
    refreshData(){
      this.visibleLab = false;
      this.pagParams.page  = 1;
      // this.pagParams.limit = 5;
      // this.pagParams.total = 5;
      this.pagParams.searchval = '';
      this.getData();
    },

    searchData(){
      this.pagParams.page = 1;
      this.getData();
    },
    _addData() {
      if (!this.tmp ){
        this.$msgNot.error('数据不能为空');
        return;
      }

      this.DialogVisible = false
      this.addData();

    },
    async getData(){

      const {data:res} = await this.$ajax.post("/api/phone/getdata",{'account':this.userName,'apptype':this.apptype,'ks':this.ks,'data':this.pagParams});
      if (res.code === 200){
        // this.tableData = res.data.reverse();
        this.tableData = res.data;
        this.pagParams.total = res.total;
      }else {
        this.$msgNot.error('获取数据失败:'+res.msg);
      }

    },
    async queryData(){

      this.visibleLab = !this.visibleLab;
      if(!this.visibleLab){
        return;
      }

      const {data:res} = await this.$ajax.post("/api/phone/querydata2",{'account':this.userName,'ks':this.ks});
      if (res.code === 200){
        this.labData = res.data;
        this.loadingLab = false;
      }else {
        this.$msgNot.error('查询用量失败:'+res.msg);
      }

    },

    async postAuth(){

      const {data:res} = await this.$ajax.post("/api/phone/setAuthMsg",{'account':this.userName,'apptype':this.apptype,'data':this.formChange});
      if (res.code === 200){
        this.$msgNot.success('设置成功');

        this.formChange.status = null;
        this.formChange.msg = '';
        this.formChange.id = null;
        this.formChange.auth = null;
        this.formChange.phone = '';
        this.formChange.auth = null;
        this.formChange.lab = '';

        this.dlgShow_Auth = false;
        await this.getData();
      }else {
        this.$msgNot.error('失败:'+res.msg+" "+res.feedback);
      }

    },
    async addData(){

      this.formAdd.data = trim(this.tmp).split('\n');
      const {data:res} = await this.$ajax.post("/api/phone/addData",{'account':this.userName,'apptype':this.apptype,'data':this.formAdd,'ks':this.ks});
      if (res.code === 200){
        this.$msgNot.success('添加成功,数量:'+ this.formAdd.data.length);
        this.formAdd.data = [];
        this.formAdd.status = 0;
        this.tmp = '';
        await this.getData();
      }else {
        this.$msgNot.error('添加数据失败:'+res.msg);
      }

    },
    async delData(row){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      await this.$msgBox.confirm('确认删除:'+row.data,'提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/phone/deldata",{'account':this.userName,'id':row.id});
            if (res.code === 200){
              this.$msgNot.success('删除成功');
              await this.getData();
            }else {
              this.$msgNot.error('删除失败:'+res.msg);
            }

          }).catch(()=>{

          });
    },


    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagParams.limit = val;
      this.getData();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagParams.page = val;
      this.getData();
    },
    filterStatus(value, row) {
      return row.status === value;
    },
    filterFeedback(value, row) {
      return row.feedback === value;
    },
    handleChange(file) {
      this.file = file.raw;
    },
    tableRowClassName({row, rowIndex}) {
      return 'warning-row';
    },
    fDate(row, column){
      return this.formatDateS(row, column);
    }
  }

}
</script>

<style>

.el-ta {
  /*background-color: #222D32;*/
  color: #000000;
  text-align: left;
  /*line-height: 150px;*/
  margin: 1px;
  padding: 1px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-table .warning-row {
  background: #f0f9eb;
}


</style>
